<template>
	<v-card v-if="item" class="mx-auto my-4" max-width="374" elevation="12">
		<v-dialog v-model="showHelp" persistent max-width="290">
			<v-card>
				<v-card-title class="text-h5">帮助提醒</v-card-title>
				<v-card-text>如果你想了解如何免费获取积分请点【了解积分】按钮前往查询。如果不想了解点击【取消】关闭窗体。</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showHelp = false">取消</v-btn>
					<v-btn to="/user/score" color="primary darken-1" text>了解积分</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showUser" persistent max-width="290">
			<v-card>
				<v-card-title class="text-h5">联系作者</v-card-title>
				<v-card-text>
					如果你不了解如何使用，请联系 Q群:18593916 。你使用积分下载，并不代表作者需要免费服务于你。免费获取的积分并下载，属于免费获取使用，不属于付费服务。
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showUser = false">我知道了</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showInstall" persistent max-width="790">
			<v-card>
				<v-card-title class="text-h5">安装说明</v-card-title>
				<v-card-text>{{ item.descpro }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showInstall = false">关闭</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dowanloadZip" persistent max-width="590">
			<v-card>
				<v-card-title class="text-h5">下载模板</v-card-title>
				<v-card-text>
					下载模板需要扣除相应积分，您应知悉！
					<br />
					下载的模板并不代表作者或者本站需要为你提供廉价的劳动力服务，因为你只是免费获取别人的劳动成果。你付出的积分也属于免费获取，并且利益微博（基于开源的精神所获取的可怜的利益）。
					<br />
					<b class="red--text">你应该同意并遵守：不私下分发本模板，自愿承担侵权的责任体。</b>
					<br />
					本站（作者tmzdy)不承担侵权责任，模板为上传之作者版权所有，但一旦上传至本站，本站享有使用，分发，使用，商用的权利
					<br />
					<b class="red--text">本站（作者tmzdy)如发现私下分发作者辛苦所作模板，我将永久关闭本站，不作任何通知！</b>
					<br />
					<b class="red--text">本站（作者tmzdy)如发现某ID肆意分发辛苦所作，立即拉黑。</b>
					<br />
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn :loading="donwing" color="primary darken-1" @click="downloadFile">已阅读并下载</v-btn>
					<v-btn :loading="donwing" color="primary darken-1" text @click="dowanloadZip = false">不下载</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showQr" persistent max-width="290">
			<v-card>
				<v-card-title class="text-h5">手机扫码预览</v-card-title>
				<v-card-text>
					<v-img :src="item.previmg+'@!pic'"></v-img>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showQr = false">取消</v-btn>
					<v-btn to="/user/score" color="primary darken-1" text>电脑访问</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<template slot="progress">
			<v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
		</template>

		<v-carousel cycle height="250px" hide-delimiter-background show-arrows-on-hover style="cursor: pointer;">
			<v-carousel-item v-for="(img, i) in item.img.split(',')" :key="i">
				<v-img @click="prevImg(img)" height="250px" contain :src="img + '@!pic'"></v-img>
			</v-carousel-item>
		</v-carousel>
		<v-card-title>{{ item.title }}</v-card-title>
		<div class="d-flex mx-4 align-center d-flex justify-space-between">
			<div class="d-flex align-center">
				需要积分：
				<h2 class="red--text">{{ item.jifen }}</h2>
			</div>
			<v-btn @click="showHelp = true" icon color="primary">
				<v-icon size="18">mdi-help</v-icon>
			</v-btn>
		</div>
		<v-card-text>
			<div class="text-subtitle-1" style="height: 44px;overflow: hidden;">{{ item.descpro }}</div>
			<div>
				<v-btn color="primary" dark text block @click="showInstall = true">阅读所有及安装说明</v-btn>
			</div>
			<!-- <div>{{ item.updateStr }}</div> -->
		</v-card-text>

		<v-divider class="mx-4"></v-divider>

		<v-card-title>作品#ID：{{ item.tmzdy_tmuiMobanID }}  作者：tm-vuetify</v-card-title>

		<v-card-text>
			<div>兼容性</div>
			<v-chip-group column>
				<v-chip v-if="item.app == 1">appvue</v-chip>
				<v-chip v-if="item.mp == 1">MP小程序</v-chip>
				<v-chip v-if="item.h5 == 1">H5</v-chip>
			</v-chip-group>
		</v-card-text>

		<v-card-actions>

			<v-btn color="grey" dark @click="showUser = true">联系作者</v-btn>
			<v-btn color="green" dark @click="showQr = true">在线预览</v-btn>
			<v-btn color="primary " @click="openLoadWin(), (dowanloadZip = true)">下载模板</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	export default {
		name: 'tm-listItem',
		props: {
			item: {
				type: Object,
				default: () => null,
				required: true
			}
		},
		data: () => ({
			showHelp: false,
			showUser: false,
			showInstall: false,
			dowanloadZip: false,
			donwing: false,
			showQr: false
		}),

		methods: {
			addSee(id) {
				this.$fetch('/tmui/addSee/?id=' + id, {
					method: 'get'
				})
				console.log(id);
			},
			prevImg(img) {
				window.open(img + '@!pic')
			},
			openLoadWin() {
				this.addSee(this.item.tmzdy_tmuiMobanID)
			},
			download(url, callback) {
				var xhr = new XMLHttpRequest();
				xhr.open('GET', url, true); // 也可以使用POST方式，根据接口
				xhr.setRequestHeader("token", this.$store.state.token);
				xhr.responseType = "blob"; // 返回类型blob
				// 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
				xhr.onload = function() {
					// 请求完成
					if (this.status === 200) {
						// 返回200
						var blob = this.response;
						var reader = new FileReader();
						reader.readAsDataURL(blob); // 转换为base64，可以直接放入a表情href
						reader.onload = function(e) {
							// 转换完成，创建一个a标签用于下载
							var a = document.createElement('a');
							a.download = new Date().getTime() + ".zip";
					  a.href = e.target?.result;
							document.body.append(a);
							a.click();
							document.body.removeChild(a);
							callback(true);
						}
						reader.onerror = function() {
							callback(false);
						}
						reader.abort = function() {
							callback(false);
						}
					}
		 	};
				// 发送ajax请求
				xhr.send()
			},
			downloadFile() {
				if (!this.$store.state.token) {
					this.$store.commit("toast", {
						msg: "你没有登录！",
						color: "red"
					})
					return;
				}
				if (!this.$store.state.userinfo) {
					this.$store.commit("toast", {
						msg: "请刷新页面，异常登录！",
						color: "red"
					})
					return;
				}

				if (parseInt(this.$store.state.userinfo.jifen) < parseInt(this.item.jifen)) {
					this.$store.commit("toast", {
						msg: "所需积分不足以兑换该模板！",
						color: "red"
					})
					return;
				}
				if (parseInt(this.$store.state.userinfo.black) == 1) {
					this.$store.commit("toast", {
						msg: "你的用户已经被拉黑",
						color: "red"
					})
					return;
				}
				let t = this;
				this.donwing = true;
				t.$store.commit("toast", {
					msg: "下载中请不要关闭窗体。",
					color: "primary"
				});
				this.download("/tmui/download?id=" + this.item.tmzdy_tmuiMobanID, function(isTure) {
					t.donwing = false;
					if (!isTure) {
						t.$store.commit("toast", {
							msg: "下载失败，请重试，不扣减积分。",
							color: "red"
						})
						return;
					}
					t.$store.commit("toast", {
						msg: "下载成功，请注意下载窗口。",
						color: "green"
					})
					t.dowanloadZip = false;
				})
			}
		}
	};
</script>

<style></style>
